<template>
  <div class="carousel-wrapper">
    <v-carousel
      v-model="currentSlide"
      class="hero-carousel"
      :cycle="!isPaused"
      :interval="7000"
      hide-delimiter-background
      show-arrows-on-hover
      :show-arrows="!isMobile"
      transition="fade-transition"
      reverse-transition="fade-transition"
      height="100%"
      role="region"
      aria-label="Promociones"
      @mouseenter.native="isPaused = true"
      @mouseleave.native="isPaused = false"
    >
      <v-carousel-item
        v-for="(item, i) in slides"
        :key="item.src"
      >
        <v-img
          :src="item.src"
          :lazy-src="item.preview"
          :alt="item.alt"
          :eager="i === 0"
          cover
          class="slider-image"
          @error="onImageError(item)"
        >
          <template #placeholder>
            <div class="d-flex align-center justify-center fill-height">
              <v-progress-circular indeterminate color="grey lighten-3" />
            </div>
          </template>

          <div class="overlay"></div>
        </v-img>
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
const BASE_IMG = process.env.VUE_APP_BASE_IMG;

// Se fija una sola vez (idealmente inyectada en build), no en cada
// montaje del componente, para no romper el cache del navegador.
const CACHE_VERSION = process.env.VUE_APP_BUILD_VERSION || Date.now();

function buildDefaultSlides() {
  return Array.from({ length: 3 }, (_, i) => ({
    src: `${BASE_IMG}/sliders/slider${i + 1}.png?v=${CACHE_VERSION}`,
    preview: `${BASE_IMG}/sliders/preview${i + 1}.jpg?v=${CACHE_VERSION}`,
    alt: `Promoción ${i + 1}`,
    title: `Slide ${i + 1}`,
    subtitle: 'Texto opcional'
  }));
}

export default {
  name: 'SliderComponent',

  props: {
    // Permite alimentar los slides desde fuera (API/CMS); si no se
    // pasa nada, usa los 3 slides por defecto de siempre.
    slides: {
      type: Array,
      default: () => buildDefaultSlides()
    }
  },

  data() {
    return {
      currentSlide: 0,
      isPaused: false
    };
  },

  computed: {
  breakpoint() {
    return this.$vuetify?.breakpoint || {};
  },

  isMobile() {
    return this.breakpoint.xs || this.breakpoint.sm;
  },

    carouselHeight() {
      if (this.breakpoint.xs) return 180;
      if (this.breakpoint.sm) return 260;
      if (this.breakpoint.md) return 280;
      if (this.breakpoint.lg) return 380;
      return 360; // xl y default
    }
  },

  methods: {
    onImageError(item) {
      // Evita que un slide roto rompa la experiencia; solo se registra.
      // Si quieres un fallback visual, aquí puedes mutar item.src.
      console.warn(`[SliderComponent] No se pudo cargar: ${item.src}`);
    }
  }
};
</script>

<style scoped>
.carousel-wrapper {
  width: 100%;
  aspect-ratio: 21 / 8;    /* misma proporción en la que exportas en Canva */
  max-height: 500px;       /* evita que se vea gigante en monitores muy anchos */
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.hero-carousel {
  height: 100%;
}

.slider-image {
  width: 100%;
  height: 100%;
}

@media (max-width: 600px) {
  .carousel-wrapper {
    aspect-ratio: 16 / 9;  /* recorte más alto en celular, como ya planeabas */
    border-radius: 12px;
  }
}
</style>